const trimTrailingSlashes = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/\/+$/, '');
};

const addTrailingSlash = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  return value.endsWith('/') ? value : `${value}/`;
};

const buildEndpoint = (baseUrl, path) => {
  const sanitizedBase = trimTrailingSlashes(baseUrl);
  if (!sanitizedBase) {
    return '';
  }

  const normalizedPath = trimTrailingSlashes(path).replace(/^\/+/, '');
  const combined = `${sanitizedBase}/${normalizedPath}`;

  return addTrailingSlash(combined);
};

const pickFirstUrl = (candidates = []) => {
  for (const candidate of candidates) {
    // Legacy API build variables may still contain the retired production host.
    const sanitized = trimTrailingSlashes(candidate).replace(
      /^(https?:\/\/)api\.juristai\.org(?=[:/]|$)/i,
      '$1api-dev.juristai.org'
    );
    if (sanitized) {
      return sanitized;
    }
  }

  return '';
};

// Fallback for builds where neither env var was injected (e.g. a Docker build
// missing the build-arg). Without it axios falls back to same-origin relative
// URLs, and the static nginx serving this SPA answers every API POST with 405.
const DEFAULT_API_BASE_URL = 'https://api-dev.juristai.org';

export const API_BASE_URL = pickFirstUrl([
  process.env.REACT_APP_ATTICUS_API_URL,
  process.env.REACT_APP_JURIST_API_URL,
  DEFAULT_API_BASE_URL,
]);

const publicBaseUrl = pickFirstUrl([
  process.env.REACT_APP_ATTICUS_PUBLIC_API_URL,
  API_BASE_URL,
]);

// Django Hub mounts the authenticated schema below /api/core. The old
// /graphql/ path is not registered and is served as a normal Django 404.
const GRAPHQL_PATH = 'api/core/graphql';
const PUBLIC_GRAPHQL_PATH = 'api/core/graphql-router';
const DEFAULT_GRAPHQL_ENDPOINT = 'https://api-dev.juristai.org/api/core/graphql/';
const DEFAULT_PUBLIC_GRAPHQL_ENDPOINT = 'https://api-dev.juristai.org/api/core/graphql-router/';

export const GRAPHQL_ENDPOINT = buildEndpoint(API_BASE_URL, GRAPHQL_PATH) || DEFAULT_GRAPHQL_ENDPOINT;

export const PUBLIC_GRAPHQL_ENDPOINT =
  buildEndpoint(publicBaseUrl, PUBLIC_GRAPHQL_PATH) || DEFAULT_PUBLIC_GRAPHQL_ENDPOINT;

export const ensureTrailingSlash = addTrailingSlash;
export const removeTrailingSlashes = trimTrailingSlashes;
